<template>
  <div v-if="showListStaff">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5>{{ title }}</h5>
                <b-button size="sm" variant="light" @click="closeModalCaringSale()"> x </b-button>
              </div>
              <div class="modal-body">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <b-input-group>
                      <b-form-input
                        v-model="searchSale.textSearch"
                        @input="fetchListSales()"
                        @keyup.enter="fetchListSales()"
                        placeholder="Tên/Email của sale"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="outline-secondary" @click="fetchListSales()"
                          >Tìm kiếm</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </div>
                <div class="table-responsive" style="max-height: 50vh; overflow-y: auto">
                  <table class="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Tên Sales</th>
                        <th>Email</th>
                        <th>Tỉnh/Thành phố</th>
                      </tr>
                    </thead>
                    <tbody v-if="loadingSale">
                      <tr>
                        <td colspan="11" align="center">
                          <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr
                        class="table-row"
                        :class="{ 'table-primary': selectedSale.includes(item.userId) }"
                        v-for="(item, index) in dataSaleSelect"
                        :key="index"
                        @click="actionSelectSale(item.userId)"
                      >
                        <td>
                          <b-form-checkbox
                            class="text-center"
                            v-model="selectedSale"
                            :value="item.userId"
                            disabled
                          />
                        </td>
                        <td>
                          {{ item.name }}
                        </td>
                        <td>
                          {{ item.userName }}
                        </td>
                        <td>
                          {{ item.provinceName }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <b-pagination
                    v-model="searchSale.page"
                    :total-rows="paginationSale.total"
                    :per-page="searchSale.limit"
                    @change="paginationChange"
                    class="fl-right mr-2"
                  ></b-pagination>
                </div>
              </div>
              <div class="modal-footer">
                <b-button size="sm" variant="light" @click="closeModalCaringSale()">
                  Đóng
                </b-button>
                <b-button
                  :disabled="selectedSale.length === 0"
                  size="sm"
                  variant="primary"
                  @click="chooseAssign()"
                >
                  Xác nhận
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  export default {
    props: {
      title: {
        type: String,
        default: 'Gán nhân viên triển khai',
      },
      showListStaff: {
        type: Boolean,
      },
    },
    mounted() {
      this.fetchListSales()
    },
    data() {
      return {
        searchSale: {
          textSearch: '',
          page: 1,
          limt: 20,
        },
        paginationSale: {
          total: null,
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loadingSale: false,
        dataSaleList: [],
        selectedSale: [],
        dataSaleSelect: [],
        selected: [],
      }
    },
    methods: {
      fetchListSales() {
        if (this.searchSale.textSearch === '') {
          this.searchSale = {
            userId: this.dataUser.userId,
          }
        }
        this.searchSale.userId = this.dataUser.userId
        // this.searchSale.region = this.getSaleRegion()
        this.getListStaffLower(this.searchSale)
      },
      getSaleRegion() {
        const arr = this.selected.map(e => {
          return e.regionId
        })
        const isExist = (arr, x) => {
          for (const i in arr) {
            if (arr[i] === x) return true
          }
          return false
        }
        const ans = []
        arr.forEach(element => {
          if (!isExist(ans, element)) ans.push(element)
        })
        return arr
      },
      // list sale lead gán
      async getListStaffLower(params) {
        try {
          this.loadingSale = true
          const data = await StaffService.getListLowerGrade(params)
          if (data.data.length > 0) {
            this.dataSaleList = data.data
            this.paginationSale.total = data.data.length
            this.searchSale.limit = 20
            this.paginationChange(1)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingSale = false
        }
      },

      actionSelectSale(item) {
        this.selectedSale = []
        this.selectedSale.push(item)
        this.selectedSale = this.selectedSale.filter(e => e === item)
      },

      chooseAssign() {
        const dataSale = this.dataSaleList.filter(e => e.userId === this.selectedSale[0])
        this.$emit('submit', { userId: this.selectedSale, dataSale: dataSale })
      },

      async paginationChange(pageIndex) {
        this.searchSale.page = pageIndex
        this.dataSaleSelect = []
        const mod = this.paginationSale.total % this.searchSale.limit
        if (
          mod === 0 ||
          (pageIndex - 1) * this.searchSale.limit < this.paginationSale.total - mod
        ) {
          for (
            let i = (pageIndex - 1) * this.searchSale.limit;
            i < pageIndex * this.searchSale.limit;
            i++
          ) {
            this.dataSaleSelect.push(this.dataSaleList[i])
          }
        } else {
          for (let i = this.paginationSale.total - mod; i < this.paginationSale.total; i++) {
            this.dataSaleSelect.push(this.dataSaleList[i])
          }
        }
      },

      closeModalCaringSale() {
        this.$emit('close')
      },
    },
  }
</script>

<style scoped>
  :deep(.modal-dialog) {
    max-width: 768px !important;
  }
</style>
